import styled from 'styled-components'
import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;

  @media ${baseTheme.device.tablet} {
    height: 100%;
  }
`

export const TitleTypography = styled(Typography)`
  margin-top: 36px;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 600;
  color: ${baseTheme.colors.lightDark};

  @media ${baseTheme.device.tablet} {
    font-size: 48px;
    font-weight: 700;
  }
`

export const DetailsTypography = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const DetailsBr = styled.br`
  @media ${baseTheme.device.tablet} {
    display: none;
  }
`
